import axios from 'axios'
import { Message } from 'element-ui'
import store from '@/store'
import router from '@/router'
import { getRefreshToken, getToken, setRefreshToken, setToken } from '@/utils/auth'

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 15000
})

let isRedirecting = false

service.interceptors.request.use(
  config => {
    const token = getToken()
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    const refreshToken = getRefreshToken()
    if (refreshToken) config.headers['X-Authorization'] = `Bearer ${refreshToken}`
    return config
  },
  error => Promise.reject(error)
)

function redirectToLogin(message) {
  if (isRedirecting) return
  isRedirecting = true
  store.dispatch('user/resetToken').finally(() => {
    const redirect = router.currentRoute.fullPath
    if (router.currentRoute.path !== '/login') {
      router.replace({ path: '/login', query: { redirect } }).catch(() => {})
    }
    Message.error(message || '登录状态已过期，请重新登录')
    window.setTimeout(() => { isRedirecting = false }, 500)
  })
}

service.interceptors.response.use(
  response => {
    const accessToken = response.headers['access-token']
    const refreshToken = response.headers['x-access-token']
    if (accessToken) setToken(accessToken)
    if (refreshToken) setRefreshToken(refreshToken)
    const payload = response.data
    if (!payload || typeof payload.code === 'undefined') return payload

    if ([0, 200, '0', '200'].includes(payload.code)) {
      return payload.data
    }

    if (Number(payload.code) === 401) {
      redirectToLogin(payload.message || payload.msg)
      return Promise.reject(new Error(payload.message || payload.msg || '登录状态已过期'))
    }

    const message = payload.message || payload.msg || '请求失败'
    if (!response.config.silent) Message.error(message)
    return Promise.reject(new Error(message))
  },
  error => {
    const response = error.response
    if (response && response.status === 401) {
      redirectToLogin(response.data && (response.data.message || response.data.msg))
      return Promise.reject(error)
    }

    const message = (response && response.data && (response.data.message || response.data.msg)) ||
      (error.code === 'ECONNABORTED' ? '请求超时，请稍后重试' : error.message) ||
      '网络异常，请检查网络连接'
    if (!error.config || !error.config.silent) Message.error(message)
    return Promise.reject(error)
  }
)

export default service
